import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { logoUrl } from '../data/mock';
import { Facebook, Instagram, Linkedin, Twitter } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();

  const socialLinks = [
    { icon: Facebook, href: '#', label: 'Facebook' },
    { icon: Instagram, href: '#', label: 'Instagram' },
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
    { icon: Twitter, href: '#', label: 'Twitter' }
  ];

  return (
    <footer className="relative bg-[#0B2E4B]">
      {/* Hexagon Pattern */}
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="footer-hex" width="50" height="43" patternUnits="userSpaceOnUse">
              <polygon 
                points="25,0 50,12.5 50,37.5 25,50 0,37.5 0,12.5" 
                fill="none" 
                stroke="#28BBC5" 
                strokeWidth="0.5"
              />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#footer-hex)" />
        </svg>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="h-16 md:h-20 w-48 md:w-56 overflow-hidden flex items-center justify-center mb-6">
              <img 
                src={logoUrl} 
                alt="BrightCore PR" 
                className="h-32 md:h-40 object-contain scale-150"
              />
            </div>
            <p className="text-white/60 max-w-sm mb-6 leading-relaxed">
              {t.footer.slogan}
            </p>
            
            {/* Social Links */}
            <div className="flex items-center gap-3">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  aria-label={social.label}
                  className="w-10 h-10 flex items-center justify-center bg-white/10 text-white/60 rounded-lg hover:bg-[#28BBC5] hover:text-white transition-all duration-300"
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-5">Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-white/60 hover:text-[#28BBC5] transition-colors duration-300">
                  {t.nav.services}
                </a>
              </li>
              <li>
                <a href="#portfolio" className="text-white/60 hover:text-[#28BBC5] transition-colors duration-300">
                  {t.nav.portfolio}
                </a>
              </li>
              <li>
                <a href="#about" className="text-white/60 hover:text-[#28BBC5] transition-colors duration-300">
                  {t.nav.about}
                </a>
              </li>
              <li>
                <a href="#contact" className="text-white/60 hover:text-[#28BBC5] transition-colors duration-300">
                  {t.nav.contact}
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-5">Legal</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-white/60 hover:text-[#28BBC5] transition-colors duration-300">
                  {t.footer.privacy}
                </a>
              </li>
              <li>
                <a href="#" className="text-white/60 hover:text-[#28BBC5] transition-colors duration-300">
                  {t.footer.terms}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <p className="text-white/40 text-sm text-center">
            {t.footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
